import { Accordion, Button, ButtonsGroup, Card, Empty, InputText } from "#/atoms";
import { DESKTOP_SPACING, HPOSITION } from "@/theme";
import { FC, memo, useCallback, useId, useMemo, useRef, useState } from "react";
import { NoteProps, NotesCardProps } from "./Notes.interface";
import { StyledNote, StyledTime } from "./Notes.styled";

import { HeadingIcon } from "#/molecules";
import { formatShortDateWithTimeString } from "@/helpers";

const Note: FC<NoteProps> = ({ label, value, time, onChange, readOnly }) => {

  return (
    <StyledNote>
      <InputText type="text" label={label} value={value} readOnly={readOnly} onChange={(e) => onChange(e.target.value) } />
      {time && <StyledTime>{formatShortDateWithTimeString(time)}</StyledTime> }
    </StyledNote>
  );
}

const NotesCard: FC<NotesCardProps> = ({ accordionState = 'open', notes, onAddNote, onCancelNote, onSaveNote, owner, isReadOnly }) => {
  const id = useId();
  const noteId = useMemo(() => `${id}-${notes.length}`, [notes, id]);
  const [editMode, setEditMode] = useState(false);
  const currentNoteContent = useRef<string>(''); 

  const handleAddNewNote = useCallback(() => {
    setEditMode(true);
    currentNoteContent.current = '';
    onAddNote({
      content: '',
      id: noteId,
      owner: owner
    })
  }, [noteId]);

  const shouldShowEmpty = notes.length === 0;

  const handleCurrentNoteChanged = useCallback((noteContent: string) => {
    currentNoteContent.current = noteContent;
  }, []);


  return (
    <Card>
      <Accordion
        header={<HeadingIcon icon="note" title="Notes" />}
        headerMargin={`${DESKTOP_SPACING.XXXL}px`}
        showArrow
        state={accordionState}
      >
        {notes.map((note, index) => {
          return (
            <Note
              key={`${noteId}-${index}`}
              id={note.id}
              value={note.content}
              label={`Note by ${note.owner}`}
              onChange={handleCurrentNoteChanged}
              readOnly={isReadOnly ?? false}
              time={note.created}
            />
          );
        })}
        {shouldShowEmpty && (
          <Empty>No notes have been added yet.</Empty>
        )}
        { !isReadOnly && <ButtonsGroup align={shouldShowEmpty ? HPOSITION.CENTER : HPOSITION.RIGHT} fullWidth>
          { editMode && <>
            <Button onClick={() => {setEditMode(false); onSaveNote?.(currentNoteContent.current); }}>
              Save
            </Button>
            <Button onClick={() => { setEditMode(false); onCancelNote?.(); }}>
              Cancel
            </Button>
          </> }
         
          {!editMode && <Button onClick={handleAddNewNote}>
            Add Note
          </Button> }
        </ButtonsGroup> }
      </Accordion>
    </Card>
  );
};

export default memo(NotesCard);